import { Flex, Text } from '@mantine/core';
import { PropsWithChildren } from 'react';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

export const SummaryItem = ({
	title,
	value,
	children,
	margin = '0.5rem 0',
	item,
}: PropsWithChildren<{
	title: string;
	value?: string | number;
	margin?: string;
	item: string;
}>) => {
	return (
		<Flex direction="column" gap="0.25rem" m={margin}>
			<Text
				fz="md"
				c="dark.0"
				fw={400}
				data-testid={`${TEST_ELEMENT_IDS.ADMIN_SUMMARY_ITEM_NAME}-${item}-${title}`}
			>
				{title}
			</Text>
			{children ?? (
				<Text
					fz="lg"
					c="dark.8"
					fw={400}
					data-testid={`${TEST_ELEMENT_IDS.ADMIN_SUMMARY_ITEM_VALUE}-${item}-${value}`}
				>
					{value}
				</Text>
			)}
		</Flex>
	);
};
